export const rolesList = [
  {
    label: "Normaler User",
    value: "ROLE_SPECIALIST",
    note: "Sieht nur seine selbst hochgeladenen Dokumente und selbst angelegten Website-Checks. Kann keine Änderungen in den Einstellungen vornehmen. ",
  },
  {
    label: "Administrator",
    value: "ROLE_TENANTADMIN",
    note: "Sieht alle Dokumente und Website-Checks (egal von welchem User hochgeladen/erstellt). Kann in den Einstellungen Änderungen vornehmen (z.B. User anlegen/löschen)",
  },

  {
    label: "Administrator (eingeschränkt)",
    value: "ROLE_TENANTADMIN_RESTRICTED",
    note: "Gleiche Rechte wie Administrator, kann aber nur seine eigenen Chats sehen.",
  },
];
// Supplementary labels for roles not offered in `rolesList` (which only feeds the
// user-role dropdown). Keeps the account display readable for every role.
const extraRoleLabels: Record<string, string> = {
  ROLE_ADMIN: "System-Administrator",
  ROLE_TENANTADMIN_RESTRICTED: "Administrator (eingeschränkt)",
  PUBLIC: "Gast",
};
export const getRoleDisplayName = (role: string) => {
  const roleLabel = rolesList.find((r) => r.value === role);
  if (roleLabel) {
    return roleLabel.label;
  }
  return extraRoleLabels[role] || role;
};

export const role = {
  admin: "ROLE_ADMIN",
  tenantAdmin: "ROLE_TENANTADMIN",
  tenantAdminRestricted: "ROLE_TENANTADMIN_RESTRICTED",
};

export type Roles = "ROLE_TENANTADMIN" | "ROLE_TENANTADMIN_RESTRICTED" | "ROLE_ADMIN" | "ROLE_SPECIALIST" | "PUBLIC";

const ROLE_KEYS = ["ROLE_TENANTADMIN", "ROLE_TENANTADMIN_RESTRICTED", "ROLE_ADMIN", "ROLE_SPECIALIST", "PUBLIC"];
export const WEBSITE_CHECK_TYPES = [
  {
    serviceName: "website-check-standard",
    label: "DSGVO (Rechtskonformität)",
    workflow: "WEB_STANDARD",
    type: "STANDARD",
    desc: `Geprüft werden:
  <br>Cookie-Banner
  <br>Cookies
  <br>Extern geladene Inhalte (inkl. Google Fonts)
  <br>Datenschutzerklärung
  <br>AGB
  <br>Impressum
  <br>Webformulare inkl. Captcha
  <br>SSL-Zertifikat`,
    isEnabled: true,
  },
  {
    serviceName: "website-check-security",
    label: "IT-Security (Website-Sicherheit)",
    workflow: "WEB_SECURITY",
    type: "STANDARD",
    desc: `Geprüft werden: 
<br>SSL-Zertifikat
<br>Extern geladene Inhalte (inkl. Google Fonts)
<br>Captchas
<br>Security Header
<br>Telefon/E-Mail in Klarschrift
<br>Eingesetzte Software + Versionscheck  `,
    isEnabled: true,
  },
  {
    serviceName: "website-check-premium",
    label: "Premium (DSGVO + IT-Security)",
    workflow: "WEB_PREMIUM",
    type: "PREMIUM",
    desc: `Geprüft werden:
  <br>Cookie-Banner
  <br>Cookies
  <br>Extern geladene Inhalte (inkl. Google Fonts)
  <br>Datenschutzerklärung
  <br>AGB
  <br>Impressum
  <br>Webformulare inkl. Captcha
  <br>SSL-Zertifikat
  <br>Security Header
  <br>Telefon/E-Mail in Klarschrift
  <br>Eingesetzte Software + Versionscheck`,
    isEnabled: true,
  },
  {
    serviceName: "website-check-swiss",
    label: "Website-Check Schweiz",
    workflow: "WEB_SWISS",
    type: "STANDARD",
    desc: `
  Cookies dürfen ohne Einverständnis aktiviert werden
  <br>Cookies müssen in Datenschutzerklärung oder Cookie-Liste angeführt werden`,
    isEnabled: true,
  },
  {
    serviceName: "website-check-swiss-2",
    label: "Website-Check Schweiz (light)",
    workflow: "WEB_SWISS_2",
    type: "STANDARD",
    desc: `
  Cookies dürfen ohne Einverständnis aktiviert werden
  <br>Cookies müssen NICHT in Datenschutzerklärung oder Cookie-Liste angeführt werden`,
    isEnabled: true,
  },
];
export const ALL_FEATURES = [
  { label: "Vertragsanalyse", value: "doc-analysis" },
  { label: "Fälle", value: "case-list" },
  { label: "Texterkennung (OCR)", value: "ocr" },
  { label: "DSGVO (Rechtskonformität)", value: "website-check-standard" },
  { label: "Premium (DSGVO + IT-Security)", value: "website-check-premium" },
  { label: "Website-Check Schweiz", value: "website-check-swiss" },
  { label: "Website-Check Schweiz  (light)", value: "website-check-swiss-2" },
  {
    label: "IT-Security (Website-Sicherheit)",
    value: "website-check-security",
  },
  { label: "Website-Check CSV", value: "website-check-csv" },
  { label: "NetzBeweis", value: "netzbeweis" },
  { label: "Rechner", value: "calculator" },
  { label: "Large Language Model", value: "llm" },
];
export function isRole(key: string): key is Roles {
  return ROLE_KEYS.includes(key as Roles);
}

export const passwordMinLength = 12;
export const passwordMaxLength = 128;

export const passwordRegExp = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$");

export const isValidPassword = (password: string) => {
  const normalized = password.replace(/\s+/g, " ").trim();
  if (password.length !== normalized.length) {
    return false;
  }
  if (password.length < passwordMinLength || password.length > passwordMaxLength) {
    return false;
  }
  return true;
};
